import { IReadBookmark } from '../interfaces/i-read-bookmark';
import { ReadSurah } from './read-surah';

export class ReadBookmark {
  ayaIndex: number;
  page: number;
  suraAName: string;
  suraIndex: number;
  suraTName: string;
  readSurah?: ReadSurah;
  isLastRead: boolean;

  constructor(data: IReadBookmark, isLastRead = false) {
    this.ayaIndex = data.ayaIndex;
    this.page = data.page;
    this.suraAName = data.suraAName;
    this.suraIndex = data.suraIndex;
    this.suraTName = data.suraTName;
    this.readSurah = data.readSurah ? new ReadSurah(data.readSurah) : undefined;
    this.isLastRead = isLastRead;
  }
}
